import { cva, type VariantProps } from "class-variance-authority";
import { type SVGProps } from "react";
import { type ArrayValues } from "@/types";

export const ICON_NAMES = [
    "arrow-bend-down-left",
    "arrow-bend-down-right",
    "arrow-down",
    "arrow-fill-down",
    "arrow-fill-up",
    "arrow-left",
    "arrow-right",
    "arrow-up",
    "bell",
    "bulb",
    "calculator",
    "calendar",
    "cart",
    "chat",
    "check-circle",
    "checkbox",
    "checkbox-checked",
    "checkbox-checked-fill",
    "checkbox-indetermined",
    "checkbox-indetermined-fill",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "chevron-up",
    "clock",
    "close",
    "copy-file",
    "delete",
    "dots-vertical",
    "download",
    "edit",
    "email",
    "facebook",
    "file",
    "file-add",
    "file-download",
    "folder",
    "forbidden-circle",
    "gear",
    "grid",
    "heart",
    "hide",
    "image",
    "indent",
    "info-circle",
    "language",
    "link",
    "linkedin",
    "list",
    "lock",
    "map-pin",
    "menu",
    "minus",
    "note",
    "outdent",
    "phone",
    "pinterest",
    "plus",
    "plus-fill-square",
    "plus-square",
    "push-pin",
    "push-pin-solid",
    "question-circle",
    "radiobutton",
    "radiobutton-fill",
    "refresh",
    "rename",
    "search",
    "show",
    "sliders",
    "sort",
    "tag",
    "triangle-down",
    "triangle-left",
    "triangle-right",
    "triangle-up",
    "twitter",
    "user",
    "vimeo",
    "warning",
    "warning-circle",
    "wrench",
    "youtube",
] as const;

export type IconName = ArrayValues<typeof ICON_NAMES>;

const iconVariants = cva("icon", {
    variants: {
        size: {
            small: "icon--sm",
            medium: "icon--md",
            large: "icon--lg",
        },
    },
    defaultVariants: {
        size: "medium",
    },
});

export type IconVariants = VariantProps<typeof iconVariants>;
export type IconProps = Omit<SVGProps<SVGSVGElement>, "children"> & IconVariants & { name: IconName };

export default function Icon({ size, className, name, ...props }: IconProps) {
    return (
        <svg {...props} className={iconVariants({ size, className })} aria-hidden="true">
            <use xlinkHref={`#${name}`} />
        </svg>
    );
}
